module.exports = __webpack_public_path__ + "assets/img/browser_light.5d345d92.png";